import AppearanceModel from '../appearance/index.model.js';
import QuestionsModel from '../questions/index.model.js';
import RecommendationsModel from '../recommendations/index.model.js';
import SearchModel from '../search/index.model.js';
const model = {
    name: 'WidgetItem',
    buildInterface: true,
    properties: {
        entity: { required: true },
        rfk_id: { required: true, name: 'rfkId' },
        recommendations: { type: 'model', model: RecommendationsModel },
        questions: { type: 'model', model: QuestionsModel },
        /*
        rfk_flags
        control which features are turned on/off for this request. Publicly available flags include: ["semsearch", "rules", "personalization", "ranking", "textualRelevanceWeights", "questionsandanswers"]. Internal only flags include: ["debug", "explain", "test", "profile", "cache] Use the prefix '+' to enable the feature or '-' to disable it, for example ["+semsearch"]
        */
        rfk_flags: { type: 'array', name: 'rfkFlags' },
        search: { type: 'model', model: SearchModel },
        sources: { type: 'array' },
        appearance: { type: 'model', model: AppearanceModel },
    },
};
export default model;
